module.exports = __webpack_public_path__ + "media/school.b607841f.svg";